import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Themtuyenvantai from "components/Danhmuc/Phanloaivantai/Themtuyenvantai.js";
import Capnhattuyenvantai from "components/Danhmuc/Phanloaivantai/Capnhattuyenvantai.js";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const vtcolumn = [
  { field: "id", headerName: "ID", width: 100, headerAlign: "center" },
  {
    field: "ten",
    headerName: "Tên",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "ma",
    headerName: "Mã",
    width: 300,
    headerAlign: "center",
  },
];

export default function Danhmuctuyenvantai() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [tuyenvantai, setTuyenvantai] = React.useState([]);
  const [tuyenvantaivalue, setTuyenvantaivalue] = React.useState(0);
  const [openthem, setOpenthem] = React.useState(false);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
  };
  const handleClosecapnhat = () => {
    setOpencapnhat(false);
  };
  const openthemvt = () => {
    setOpenthem(true);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const gettuyenvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getloaituyenvantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTuyenvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    gettuyenvantai();
  }, []);
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={openthemvt}
          style={{ height: 27 }}
        >
          Thêm mới
        </Button>
        <Button
          variant="contained"
          style={{
            marginLeft: 10,
            color: "#fff",
            backgroundColor: "#BB2124",
            height: 27,
          }}
        >
          Xóa
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={tuyenvantai}
            columns={vtcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setTuyenvantaivalue(params.row.id);
                setOpencapnhat(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
        <a style={{ color: "#e50606", fontWeight: 700 }}>
          (*) Double click vào mỗi dòng danh mục để cập nhật
        </a>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm tuyến vận tải
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themtuyenvantai />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opencapnhat}
          onClose={handleClosecapnhat}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật tuyến vận tải
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosecapnhat} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhattuyenvantai tuyenvantaivalue={tuyenvantaivalue} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
    </GridContainer>
  );
}
